import { jsx as s } from "react/jsx-runtime";
import { Suspense as e, lazy as t } from "react";
const o = (a) => (i) => /* @__PURE__ */ s(e, { children: /* @__PURE__ */ s(a, { ...i }) }), n = o(t(() => import("./icon.js").then((a) => a.b))), c = o(t(() => import("./whatsapp.js"))), p = o(t(() => import("./analytics.js"))), m = o(t(() => import("./arrow-down.js"))), l = o(t(() => import("./arrow-left.js"))), d = o(t(() => import("./arrow-right.js"))), f = o(t(() => import("./arrow-up.js"))), h = o(t(() => import("./back.js"))), u = o(t(() => import("./brain.js"))), b = o(t(() => import("./bullet.js"))), k = o(t(() => import("./calendar.js"))), g = o(t(() => import("./camera-off.js"))), C = o(t(() => import("./camera-on.js"))), y = o(t(() => import("./camera.js"))), F = o(t(() => import("./card-edit.js"))), S = o(t(() => import("./chart.js"))), w = o(t(() => import("./chat.js"))), E = o(t(() => import("./check.js"))), M = o(t(() => import("./clip.js"))), j = o(t(() => import("./clipboard-saved.js"))), H = o(t(() => import("./clipboard.js"))), L = o(t(() => import("./clock.js"))), O = o(t(() => import("./close.js"))), P = o(t(() => import("./copy.js"))), R = o(t(() => import("./credit-card.js"))), x = o(t(() => import("./credit-cards.js"))), D = o(t(() => import("./dashboard.js"))), I = o(t(() => import("./details.js"))), z = o(t(() => import("./discount.js"))), A = o(t(() => import("./dislike.js"))), B = o(t(() => import("./doctor-talk.js"))), v = o(t(() => import("./document-calculator.js"))), U = o(t(() => import("./download.js"))), T = o(t(() => import("./edit.js"))), W = o(t(() => import("./email.js"))), N = o(t(() => import("./emoji-happy.js"))), _ = o(t(() => import("./emoji-neutral.js"))), Z = o(t(() => import("./emoji-sad.js"))), J = o(t(() => import("./error.js"))), K = o(t(() => import("./exercise.js"))), q = o(t(() => import("./exit.js"))), G = o(t(() => import("./eye-off.js"))), Q = o(t(() => import("./eye-on.js"))), V = o(t(() => import("./face-id.js"))), X = o(t(() => import("./fail.js"))), Y = o(t(() => import("./file-check.js"))), $ = o(t(() => import("./file-crossed.js"))), tt = o(t(() => import("./file-error.js"))), ot = o(t(() => import("./file-image.js"))), at = o(t(() => import("./file-pdf.js"))), st = o(t(() => import("./file-spreadsheet.js"))), rt = o(t(() => import("./file-text.js"))), it = o(t(() => import("./file-warning.js"))), et = o(t(() => import("./file.js"))), nt = o(t(() => import("./fill-heart.js"))), ct = o(t(() => import("./filter-error.js"))), pt = o(t(() => import("./filter.js"))), mt = o(t(() => import("./flag.js"))), lt = o(t(() => import("./folder.js"))), dt = o(t(() => import("./font-bold.js"))), ft = o(t(() => import("./font-italic.js"))), ht = o(t(() => import("./font-underline.js"))), ut = o(t(() => import("./frame.js"))), bt = o(t(() => import("./fullscreen.js"))), kt = o(t(() => import("./group.js"))), gt = o(t(() => import("./hand-heart.js"))), Ct = o(t(() => import("./hand-key.js"))), yt = o(t(() => import("./health-benefit.js"))), Ft = o(t(() => import("./heart.js"))), St = o(t(() => import("./heartbeat.js"))), wt = o(t(() => import("./home.js"))), Et = o(t(() => import("./hospital.js"))), Mt = o(t(() => import("./image.js"))), jt = o(t(() => import("./information.js"))), Ht = o(t(() => import("./insurance-card.js"))), Lt = o(t(() => import("./justify-center.js"))), Ot = o(t(() => import("./justify-left.js"))), Pt = o(t(() => import("./key.js"))), Rt = o(t(() => import("./lab-benefit.js"))), xt = o(t(() => import("./left-arrow-circle.js"))), Dt = o(t(() => import("./like.js"))), It = o(t(() => import("./link.js"))), zt = o(t(() => import("./lock.js"))), At = o(t(() => import("./mask.js"))), Bt = o(t(() => import("./medical-certificate.js"))), vt = o(t(() => import("./medical-cross.js"))), Ut = o(t(() => import("./medicine-search.js"))), Tt = o(t(() => import("./menu.js"))), Wt = o(t(() => import("./microphone-off.js"))), Nt = o(t(() => import("./microphone-on.js"))), _t = o(t(() => import("./minimize.js"))), Zt = o(t(() => import("./miniplayer.js"))), Jt = o(t(() => import("./mobile.js"))), Kt = o(t(() => import("./more.js"))), qt = o(t(() => import("./notes.js"))), Gt = o(t(() => import("./notification.js"))), Qt = o(t(() => import("./overflow.js"))), Vt = o(t(() => import("./paragraph-list.js"))), Xt = o(t(() => import("./paragraph-number.js"))), Yt = o(t(() => import("./phone-on.js"))), $t = o(t(() => import("./pill.js"))), to = o(t(() => import("./plus.js"))), oo = o(t(() => import("./print.js"))), ao = o(t(() => import("./profile-checkmark.js"))), so = o(t(() => import("./pulse.js"))), ro = o(t(() => import("./question.js"))), io = o(t(() => import("./receipt-bullet.js"))), eo = o(t(() => import("./receipt.js"))), no = o(t(() => import("./refresh.js"))), co = o(t(() => import("./rotate-left.js"))), po = o(t(() => import("./rotate-right.js"))), mo = o(t(() => import("./rotate.js"))), lo = o(t(() => import("./ruler.js"))), fo = o(t(() => import("./salad.js"))), ho = o(t(() => import("./scale-weight.js"))), uo = o(t(() => import("./search.js"))), bo = o(t(() => import("./select-all.js"))), ko = o(t(() => import("./send.js"))), go = o(t(() => import("./settings.js"))), Co = o(t(() => import("./share-screen.js"))), yo = o(t(() => import("./shield-heart.js"))), Fo = o(t(() => import("./star-fill.js"))), So = o(t(() => import("./star.js"))), wo = o(t(() => import("./stethoscope.js"))), Eo = o(t(() => import("./stop.js"))), Mo = o(t(() => import("./success.js"))), jo = o(t(() => import("./support.js"))), Ho = o(t(() => import("./syringe.js"))), Lo = o(t(() => import("./time-zone.js"))), Oo = o(t(() => import("./trash.js"))), Po = o(t(() => import("./unlock.js"))), Ro = o(t(() => import("./up.js"))), xo = o(t(() => import("./user-error.js"))), Do = o(t(() => import("./user.js"))), Io = o(t(() => import("./volume-full.js"))), zo = o(t(() => import("./warning.js"))), Ao = o(t(() => import("./wifi.js"))), Bo = o(t(() => import("./zoom-in.js"))), vo = o(t(() => import("./zoom-out.js"))), r = [
  "whatsapp",
  "analytics",
  "arrow-down",
  "arrow-left",
  "arrow-right",
  "arrow-up",
  "back",
  "brain",
  "bullet",
  "calendar",
  "camera-off",
  "camera-on",
  "camera",
  "card-edit",
  "chart",
  "chat",
  "check",
  "clip",
  "clipboard-saved",
  "clipboard",
  "clock",
  "close",
  "copy",
  "credit-card",
  "credit-cards",
  "dashboard",
  "details",
  "discount",
  "dislike",
  "doctor-talk",
  "document-calculator",
  "download",
  "edit",
  "email",
  "emoji-happy",
  "emoji-neutral",
  "emoji-sad",
  "error",
  "exercise",
  "exit",
  "eye-off",
  "eye-on",
  "face-id",
  "fail",
  "file-check",
  "file-crossed",
  "file-error",
  "file-image",
  "file-pdf",
  "file-spreadsheet",
  "file-text",
  "file-warning",
  "file",
  "fill-heart",
  "filter-error",
  "filter",
  "flag",
  "folder",
  "font-bold",
  "font-italic",
  "font-underline",
  "frame",
  "fullscreen",
  "group",
  "hand-heart",
  "hand-key",
  "health-benefit",
  "heart",
  "heartbeat",
  "home",
  "hospital",
  "image",
  "information",
  "insurance-card",
  "justify-center",
  "justify-left",
  "key",
  "lab-benefit",
  "left-arrow-circle",
  "like",
  "link",
  "lock",
  "mask",
  "medical-certificate",
  "medical-cross",
  "medicine-search",
  "menu",
  "microphone-off",
  "microphone-on",
  "minimize",
  "miniplayer",
  "mobile",
  "more",
  "notes",
  "notification",
  "overflow",
  "paragraph-list",
  "paragraph-number",
  "phone-on",
  "pill",
  "plus",
  "print",
  "profile-checkmark",
  "pulse",
  "question",
  "receipt-bullet",
  "receipt",
  "refresh",
  "rotate-left",
  "rotate-right",
  "rotate",
  "ruler",
  "salad",
  "scale-weight",
  "search",
  "select-all",
  "send",
  "settings",
  "share-screen",
  "shield-heart",
  "star-fill",
  "star",
  "stethoscope",
  "stop",
  "success",
  "support",
  "syringe",
  "time-zone",
  "trash",
  "unlock",
  "up",
  "user-error",
  "user",
  "volume-full",
  "warning",
  "wifi",
  "zoom-in",
  "zoom-out"
], Uo = [...r], No = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Analytics: p,
  ArrowDown: m,
  ArrowLeft: l,
  ArrowRight: d,
  ArrowUp: f,
  Back: h,
  Brain: u,
  Bullet: b,
  Calendar: k,
  Camera: y,
  CameraOff: g,
  CameraOn: C,
  CardEdit: F,
  Chart: S,
  Chat: w,
  Check: E,
  Clip: M,
  Clipboard: H,
  ClipboardSaved: j,
  Clock: L,
  Close: O,
  Copy: P,
  CreditCard: R,
  CreditCards: x,
  Dashboard: D,
  Details: I,
  Discount: z,
  Dislike: A,
  DoctorTalk: B,
  DocumentCalculator: v,
  Download: U,
  Edit: T,
  Email: W,
  EmojiHappy: N,
  EmojiNeutral: _,
  EmojiSad: Z,
  Error: J,
  Exercise: K,
  Exit: q,
  EyeOff: G,
  EyeOn: Q,
  FaceId: V,
  Fail: X,
  File: et,
  FileCheck: Y,
  FileCrossed: $,
  FileError: tt,
  FileImage: ot,
  FilePdf: at,
  FileSpreadsheet: st,
  FileText: rt,
  FileWarning: it,
  FillHeart: nt,
  Filter: pt,
  FilterError: ct,
  Flag: mt,
  Folder: lt,
  FontBold: dt,
  FontItalic: ft,
  FontUnderline: ht,
  Frame: ut,
  Fullscreen: bt,
  Group: kt,
  HandHeart: gt,
  HandKey: Ct,
  HealthBenefit: yt,
  Heart: Ft,
  Heartbeat: St,
  Home: wt,
  Hospital: Et,
  Icon: n,
  Image: Mt,
  Information: jt,
  InsuranceCard: Ht,
  JustifyCenter: Lt,
  JustifyLeft: Ot,
  Key: Pt,
  LabBenefit: Rt,
  LeftArrowCircle: xt,
  Like: Dt,
  Link: It,
  Lock: zt,
  Mask: At,
  MedicalCertificate: Bt,
  MedicalCross: vt,
  MedicineSearch: Ut,
  Menu: Tt,
  MicrophoneOff: Wt,
  MicrophoneOn: Nt,
  Minimize: _t,
  Miniplayer: Zt,
  Mobile: Jt,
  More: Kt,
  Notes: qt,
  Notification: Gt,
  Overflow: Qt,
  ParagraphList: Vt,
  ParagraphNumber: Xt,
  PhoneOn: Yt,
  Pill: $t,
  Plus: to,
  Print: oo,
  ProfileCheckmark: ao,
  Pulse: so,
  Question: ro,
  Receipt: eo,
  ReceiptBullet: io,
  Refresh: no,
  Rotate: mo,
  RotateLeft: co,
  RotateRight: po,
  Ruler: lo,
  Salad: fo,
  ScaleWeight: ho,
  Search: uo,
  SelectAll: bo,
  Send: ko,
  Settings: go,
  ShareScreen: Co,
  ShieldHeart: yo,
  Star: So,
  StarFill: Fo,
  Stethoscope: wo,
  Stop: Eo,
  Success: Mo,
  Support: jo,
  Syringe: Ho,
  TimeZone: Lo,
  Trash: Oo,
  Unlock: Po,
  Up: Ro,
  User: Do,
  UserError: xo,
  VolumeFull: Io,
  Warning: zo,
  Whatsapp: c,
  Wifi: Ao,
  ZoomIn: Bo,
  ZoomOut: vo,
  iconList: Uo,
  iconMap: r
}, Symbol.toStringTag, { value: "Module" }));
export {
  st as $,
  p as A,
  h as B,
  k as C,
  D,
  A as E,
  B as F,
  v as G,
  U as H,
  n as I,
  T as J,
  W as K,
  N as L,
  _ as M,
  Z as N,
  J as O,
  K as P,
  q as Q,
  G as R,
  Q as S,
  V as T,
  X as U,
  Y as V,
  c as W,
  $ as X,
  tt as Y,
  ot as Z,
  at as _,
  r as a,
  ho as a$,
  rt as a0,
  it as a1,
  et as a2,
  nt as a3,
  ct as a4,
  pt as a5,
  mt as a6,
  lt as a7,
  dt as a8,
  ft as a9,
  Tt as aA,
  Wt as aB,
  Nt as aC,
  _t as aD,
  Zt as aE,
  Jt as aF,
  Kt as aG,
  qt as aH,
  Gt as aI,
  Qt as aJ,
  Vt as aK,
  Xt as aL,
  Yt as aM,
  $t as aN,
  to as aO,
  oo as aP,
  ao as aQ,
  so as aR,
  ro as aS,
  io as aT,
  eo as aU,
  no as aV,
  co as aW,
  po as aX,
  mo as aY,
  lo as aZ,
  fo as a_,
  ht as aa,
  ut as ab,
  bt as ac,
  kt as ad,
  gt as ae,
  Ct as af,
  yt as ag,
  Ft as ah,
  St as ai,
  wt as aj,
  Et as ak,
  Mt as al,
  jt as am,
  Ht as an,
  Lt as ao,
  Ot as ap,
  Pt as aq,
  Rt as ar,
  xt as as,
  Dt as at,
  It as au,
  zt as av,
  At as aw,
  Bt as ax,
  vt as ay,
  Ut as az,
  Uo as b,
  uo as b0,
  bo as b1,
  ko as b2,
  go as b3,
  Co as b4,
  yo as b5,
  Fo as b6,
  So as b7,
  wo as b8,
  Eo as b9,
  Mo as ba,
  jo as bb,
  Ho as bc,
  Lo as bd,
  Oo as be,
  Po as bf,
  Ro as bg,
  xo as bh,
  Do as bi,
  Io as bj,
  zo as bk,
  Ao as bl,
  Bo as bm,
  vo as bn,
  o as bo,
  m as c,
  l as d,
  d as e,
  f,
  u as g,
  b as h,
  No as i,
  g as j,
  C as k,
  y as l,
  F as m,
  S as n,
  w as o,
  E as p,
  M as q,
  j as r,
  H as s,
  L as t,
  O as u,
  P as v,
  R as w,
  x,
  I as y,
  z
};
//# sourceMappingURL=icons-map.ts.js.map
